import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-waiting-screen" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dialog-waiting" }, [
    /*#__PURE__*/_createElementVNode("svg", null, [
      /*#__PURE__*/_createElementVNode("use", { href: "#animation-waiting" })
    ])
  ])
], -1)
const _hoisted_2 = {
  key: 0,
  class: "dialog-title"
}
const _hoisted_3 = { class: "dialog-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lang_selector = _resolveComponent("lang-selector")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dialog-screen", _ctx.cssClass])
  }, [
    _createElementVNode("div", {
      class: "dialog-window",
      style: _normalizeStyle({ minWidth: _ctx.minWidth, maxWidth: _ctx.maxWidth, minHeight: _ctx.minHeight, maxHeight: _ctx.maxHeightComputed })
    }, [
      _hoisted_1,
      (_ctx.showTitle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "title")
          ]))
        : _createCommentVNode("", true),
      (_ctx.showLangSelector)
        ? (_openBlock(), _createBlock(_component_lang_selector, { key: 1 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "dialog-body",
        style: _normalizeStyle({ minHeight: _ctx.minBodyHeight, maxHeight: _ctx.maxBodyHeight })
      }, [
        _renderSlot(_ctx.$slots, "body")
      ], 4),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "buttons")
      ])
    ], 4)
  ], 2))
}